import * as XLSX from 'xlsx';

import type { RouteCandidate } from '@/features/network/models';

export function downloadJson(filename: string, data: unknown) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadRoutesXlsx(filename: string, routes: RouteCandidate[]) {
  const rows = routes.flatMap((route, routeIndex) =>
    route.edges.map((edge, edgeIndex) => ({
      route: routeIndex + 1,
      segment: edgeIndex + 1,
      from: route.nodes[edgeIndex],
      to: route.nodes[edgeIndex + 1],
      subject: edge.subject,
      serviceId: edge.serviceId,
      status: edge.status,
      vendor: edge.vendorName,
      serviceType: edge.serviceType,
      circuitType: edge.circuitType,
      latencyMs: edge.expectedRtdMs ?? edge.slaRtdMs ?? null,
      capacityMbps: edge.capacityMbps,
      mrc: edge.mrc,
      nrc: edge.nrc,
      totalRouteLatencyMs: route.totalLatencyMs,
      totalRouteMrc: route.totalMrc,
      totalRouteNrc: route.totalNrc,
      totalRouteHops: route.hops,
      bottleneckMbps: route.bottleneckMbps,
    })),
  );

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Routes');
  const output = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([output], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
